module.exports = __webpack_public_path__ + "media/images/front/banner_cadcam-213786283efdc49759f6e62f5df99e3d.jpg";